<template>
  <v-row>
    <!-- First Name -->
    <v-col cols="12" md="6">
      <v-text-field v-model="FirstName" :rules="fieldRules" label="First name" required></v-text-field>
    </v-col>

    <!-- Last Name -->
    <v-col cols="12" md="6">
      <v-text-field v-model="LastName" :rules="fieldRules" label="Last name" required></v-text-field>
    </v-col>

    <!-- Email -->
    <v-col cols="12">
      <v-text-field v-model="Email" :rules="emailRules" label="Email" type="email" required></v-text-field>
    </v-col>

    <!-- Your Contact Number -->
    <v-col cols="12" md="6">
      <v-text-field
        v-model="ContactNum"
        :rules="fieldRules"
        label="Your Contact Number"
        type="number"
        required
      ></v-text-field>
    </v-col>

    <!-- Secondary Emergency Contact Number -->
    <v-col cols="12" md="6">
      <v-text-field v-model="EmergencyContactNum" label="Emergency Contact Number" type="number"></v-text-field>
    </v-col>

    <!-- Furry kid's name -->
    <v-col cols="12">
      <v-text-field
        v-model="FurryKidsNames"
        :rules="fieldRules"
        label="Furry kids' name(s)"
        required
      ></v-text-field>
    </v-col>

    <!-- Furry kid's breed -->
    <v-col cols="12">
      <v-text-field
        v-model="FurryKidsBreeds"
        :rules="fieldRules"
        label="Furry kids' breed(s)"
        required
      ></v-text-field>
    </v-col>

    <!-- Anything that you want us to know about your furry kid -->
    <v-col cols="12">
      <v-textarea
        v-model="FurryKidsOptional"
        name="input-7-1"
        label="Anything that you want us to know about your furry kid(s)?"
        value
        hint="Optional*"
      ></v-textarea>
    </v-col>

    <!-- Terms -->
    <v-col cols="12">
      <div>Terms: Payments are non refundable. Love Paws Homestay shall not hold responsible for any lost/escaped pets, illness and/or death whilst pets are being boarded. Pet owners is in consent to any emergency medical care required by boarders and shall be responsible to pay for such emergencies. All charges shall be paid in advance upon check-in. Overstays must be settled before pets are released. Unpaid for and/or uncollected pets will be disposed off as abandoned pets after 15 days from date of payment/collection due date. Love Paws Homestay reserves the sole right to do as they deem thereafter without further notice. Love Paws Homestay is then released of their responsibilities for the pets boarded under these terms. Love Paws Homestay has the right to reject any pets which Love Paws Homestay deemed unhealthy or any other reasons.</div>
      <v-checkbox hide-details v-model="TermsCheckbox" label="I Agree"></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    // modals
    FirstName: "",
    LastName: "",
    Email: "",
    ContactNum: "",
    EmergencyContactNum: "",
    FurryKidsNames: "",
    FurryKidsBreeds: "",
    FurryKidsOptional: "",
    TermsCheckbox: false,

    // rules
    fieldRules: [v => !!v || "This is required"],
    emailRules: [
      v => !!v || "This is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ]
  }),
  watch: {
    FirstName: function(val) {
      this.$emit("change", "FirstName", val);
    },
    LastName: function(val) {
      this.$emit("change", "LastName", val);
    },
    Email: function(val) {
      this.$emit("change", "Email", val);
    },
    ContactNum: function(val) {
      this.$emit("change", "ContactNum", val);
    },
    EmergencyContactNum: function(val) {
      this.$emit("change", "EmergencyContactNum", val);
    },
    FurryKidsNames: function(val) {
      this.$emit("change", "FurryKidsNames", val);
    },
    FurryKidsBreeds: function(val) {
      this.$emit("change", "FurryKidsBreeds", val);
    },
    FurryKidsOptional: function(val) {
      this.$emit("change", "FurryKidsOptional", val);
    },
    TermsCheckbox: function(val) {
      this.$emit("change", "TermsChecked", val);
    }
  }
};
</script>